module.exports = __webpack_public_path__ + "img/рз_22.d54c941d.png";